import { FeatureFlagEnum } from '#root/config/enums/feature-flag.enum'
import { Permissions } from './permission.enum'

export enum RouteEnum {
  CRM_DASHBOARD = "/dashboard",
  CRM_CLIENTS = "/crm/customers",
  CRM_CLIENTS_DETAIL = "/crm/customers/:id",
  CRM_UNIDENTIFIED_PAYER_PAYMENTS = "/crm/unidentified-payer-payments",
  CRM_EVALUATIONS = "/crm/evaluations",
  CRM_EVALUATIONS_DETAIL = "/crm/evaluations/details/:id",
  CRM_EVALUATIONS_CREATE = "/crm/evaluations/create",
  CRM_PROSPECTS = "/crm/prospects",
  CRM_PROSPECTS_DETAIL = "/crm/prospects/:id",
  CRM_OPPORTUNITY = "/crm/opportunity",
  CRM_OPPORTUNITY_DETAIL = "/crm/opportunity/:id",
  CRM_PAYMENT_ORDERS = "/crm/payment-orders",
  CRM_PAYMENT_ORDERS_DETAIL = "/crm/payment-orders/details/:id",
  CRM_PENDING_INVOICES = "/crm/pending-invoices",
  CRM_PAYMENTS_WEEK = "/crm/payments-of-week",
  CRM_ACTIVITIES = "/crm/activities",
  CRM_COMMISSION_CENTER = "/crm/commission-center",
  CRM_COMMISSION_CENTER_DETAIL = "/crm/commission-center/:id",
  CRM_COMMISSION_PAYMENTS = "/crm/commission-payments",
  CRM_SALES_ADVISORS = "/crm/salesAdvisors",
  CRM_PAYMENTS_REQUEST = "/crm/payments-request",
  CRM_CESSION = "/crm/cession-of-right",
  CRM_CESSION_DETAIL = "/crm/cession-of-right/:id",
  CRM_PRODUCT_CHANGE = "/crm/change-of-product",
  CRM_WITHDRAWALS = "/crm/withdrawal-requests",
  CRM_GOAL_COMMISSIONS_MINE = "/crm/goal-commissions/mine",
  CRM_GOAL_COMMISSIONS_MANAGE = "/crm/goal-commissions/manage",
  CRM_GOAL_COMMISSIONS_SETTINGS = "/crm/goal-commissions/settings",

  // Reportes
  CRM_REPORTS = "/crm/report",
  CRM_REPORT_OLD_BALANCES = "/crm/report/old-balances",
  CRM_REPORT_CUSTOMER_PAYMENT_STATUS = "/crm/report/customers-payment-status",
  CRM_REPORT_CUSTOMER_PAYMENT_GROUP = "/crm/report/customers-payment-group",
  CRM_REPORT_CLIENTS_BY_QUOTED_PRODUCT = "/crm/report/clients-by-quoted-product",
  CRM_REPORT_PENDING_WITHDRAWAL = "/crm/report/pending-with-drawal",
  CRM_REPORT_WITHDRAWALS = "/crm/report/withdrawals-report",
  CRM_REPORT_PENALTY_WITHDRAWAL = "/crm/report/penalty-withdrawal-report",
  CRM_REPORT_GENERAL_LEADS = "/crm/report/general-leads-report",
  CRM_REPORT_LOSS_REASONS = "/crm/report/loss-reason-report",
  CRM_REPORT_INTERNAL_EXTERNAL_SALES = "/crm/report/internal-external-sales-report",
  CRM_REPORT_CUSTOMERS_ADVISOR = "/crm/report/customers-advisor",
  CRM_REPORT_ADVISOR_PAYMENT_STATUS = "/crm/report/advisor-payment-status",
  CRM_REPORT_ADVISOR_ACTIVITIES = "/crm/report/advisor-activities",
  CRM_REPORT_TOP_SOLD = "/crm/report/top-sold",
  CRM_REPORT_TOP_QUOTED = "/crm/report/top-quote",
  CRM_REPORT_QUOTED_PRODUCTS_CLIENT = "/crm/report/quoted-products-client",
  CRM_REPORT_OPPORTUNITY_ORIGINS = "/crm/report/opportunity-origins",
  CRM_REPORT_ADVISOR_GOAL = "/crm/report/advisor-goal",
  CRM_REPORT_MASTER = "/crm/report/master",
  CRM_REPORT_MASTER_LEADS = "/crm/report/master-leads",
  CRM_REPORT_MASTER_CLIENTS = "/crm/report/master-client",
  CRM_REPORT_MASTER_PRODUCTS = "/crm/report/master-product",
  CRM_REPORT_AVAILABLE_PRODUCTS = "/crm/report/available-products",
  CRM_REPORT_PAYMENTS_HISTORY = "/crm/report/payments-history",
  CRM_REPORT_RESERVE_PAYMENTS = "/crm/report/payments-reserve-history",
  CRM_REPORT_ACTIVE_CUSTOMERS = "/crm/report/customer-info-report",
  CRM_REPORT_DOCUMENTATION = "/crm/report/documentation-compliance",
  CRM_REPORT_PAID_COMMISSIONS = "/crm/report/paid-commission-per-month",
  CRM_REPORT_PENDING_COMMISSIONS = "/crm/report/pending-paid-commissions",
  CRM_REPORT_COMMISSIONS_PROJECT = "/crm/report/commissions-per-project",
  CRM_REPORT_COMMISSIONS_AVAILABLE = "/crm/report/commissions-available-for-payment",
  CRM_REPORT_ACCOUNTS_RECEIVABLE = "/crm/report/accounts-receivable",
  CRM_REPORT_OPPORTUNITY_STEP_TRANSITION_TIME = "/crm/report/opportunity-step-transition-time",
  CRM_REPORT_PAYMENT_SAP_RECONCILIATION = "/crm/report/payment-sap-reconciliation",
  CRM_REPORT_RESERVATION_CONTRACT = "/crm/report/reservation-contract",

  // Inventario
  INVENTORY_PRODUCTS = "/inventory/products",
  INVENTORY_CATEGORIES = "/inventory/categoryProducts/categories",
  INVENTORY_SUBCATEGORIES = "/inventory/categoryProducts/subcategories",
  INVENTORY_CHARACTERISTICS = "/inventory/characteristics",

  // Ecommerce
  ECOMMERCE_BUSINESS_DATA = "/ecommerce/businessData",
  ECOMMERCE_PROJECTS = "/ecommerce/project",
  ECOMMERCE_COMMISSIONS = "/ecommerce/commissions",

  // Global Config
  GLOBAL_CONFIG_AD_CAMPAIGN = "/crm/adCampaign",
  GLOBAL_CONFIG_BANKS = "/globalConfig/banks",
  GLOBAL_CONFIG_PAYMENT_ACCOUNTS = "/globalConfig/paymentAccounts",
  GLOBAL_CONFIG_DOCUMENT = "/globalConfig/document",
  GLOBAL_CONFIG_DOCUMENT_LIST = "/globalConfig/document/list",
  GLOBAL_CONFIG_DOCUMENT_TYPE = "/globalConfig/document/documentTypes",
  GLOBAL_CONFIG_ORIGIN_TYPE = "/globalConfig/origin/typeOrigins",
  GLOBAL_CONFIG_PEP_TYPES = "/globalConfig/pepTypes",
  GLOBAL_CONFIG_EVALUATION_REASONS = "/globalConfig/evaluationReasons",
  GLOBAL_CONFIG_ACTIVITY = "/globalConfig/activity",
  GLOBAL_CONFIG_ACTIVITY_LIST = "/globalConfig/activity/list",
  GLOBAL_CONFIG_ACTIVITY_TYPE = "/globalConfig/activity/activityTypes",
  GLOBAL_CONFIG_TYPE_COMMISSIONS = "/globalConfig/type-commissions",
  GLOBAL_CONFIG_MEASURE_UNIT = "/globalConfig/measureUnit",
  GLOBAL_CONFIG_STATUS = "/globalConfig/status",
  GLOBAL_CONFIG_STATUS_LIST = "/globalConfig/status/list",
  GLOBAL_CONFIG_STATUS_TYPES = "/globalConfig/status/typeStatus",
  GLOBAL_CONFIG_LOCATIONS = "/globalConfig/locations",
  GLOBAL_CONFIG_LOCATIONS_DEPARTMENTS = "/globalConfig/locations/departments",
  GLOBAL_CONFIG_LOCATIONS_CITIES = "/globalConfig/locations/cities",
  GLOBAL_CONFIG_WIN_REASONS = "/globalConfig/winReasons",
  GLOBAL_CONFIG_LOSS_REASONS = "/globalConfig/lossReasons",
  GLOBAL_CONFIG_LOSS_REASON_CATEGORIES = "/globalConfig/lossReasonCategories",
  GLOBAL_CONFIG_PAYMENT_REASONS = "/globalConfig/paymentReasons",
  GLOBAL_CONFIG_ROLES = "/globalConfig/roles",
  GLOBAL_CONFIG_USERS = "/globalConfig/users",
  GLOBAL_CONFIG_NOTIFICATIONS = "/globalConfig/notifications",
  GLOBAL_CONFIG_DISCARD_REASONS = "/globalConfig/discardReasons",
  GLOBAL_CONFIG_DISCOUNT_TYPES = "/globalConfig/discountTypes",
  GLOBAL_CONFIG_GOAL_PARAMETERS = "/globalConfig/goals",
  GLOBAL_CONFIG_GOALS = "/globalConfig/goals/manage",
  GLOBAL_CONFIG_GOAL_NEW = "/globalConfig/goals/manage/new",
  GLOBAL_CONFIG_GOAL_EDIT = "/globalConfig/goals/manage/:id",
  GLOBAL_CONFIG_GOAL_METRICS = "/globalConfig/goals/metrics",
  GLOBAL_CONFIG_PROSPECT_STATUS = "/globalConfig/prospectStatus",
  GLOBAL_CONFIG_PROSPECT_STEP_STATUS = "/globalConfig/prospectStepStatus",
  GLOBAL_CONFIG_EXCHANGE_RATES = "/globalConfig/exchangeRates",
}

export interface RouteMapItem {
  mode: 'any' | 'all'
  permissions: Permissions[]
  featureFlag?: FeatureFlagEnum
  hideWhenFeatureEnabled?: FeatureFlagEnum
}

export interface RoutePermissionMap {
  [key: string]: RouteMapItem
}

export const ROUTEPERMISSIONS: RoutePermissionMap = {
  // [RouteEnum.CRM_DASHBOARD as string]: {
  //   permissions: [
  //       Permissions.CanViewAllKpis,
  //       Permissions.CanViewBreakEvenPointKpi,
  //       Permissions.CanViewPendingPremiumAmountReceivableSummaryKpi,
  //       Permissions.CanViewProjectAreaSummaryKpi,
  //       Permissions.CanViewProjectIncomeSummaryKpi,
  //       Permissions.CanViewProjectReservedIncomeSummaryKpi,
  //       Permissions.CanViewProjectSubcategoriesSummaryKpi,
  //       Permissions.CanViewTotalCommissionKpis,
  //       Permissions.CanViewAdvisorKpis,
  //       Permissions.CanViewOpportunitiesKpis,
  //       Permissions.CanViewSalesPerMonthKpi,
  //       Permissions.CanViewLeadsKpis,
  //       Permissions.CanViewProductStatusKpis,
  //       Permissions.CanViewTotalComparativeKpis,
  //       Permissions.CanViewPaymentRequestKpi,
  //       Permissions.CanViewClientsPerProjectKpi,
  //   ],
  //   mode: "any",
  // },
  [RouteEnum.CRM_CLIENTS as string]: {
    permissions: [Permissions.CanViewCustomers],
    mode: 'all',
  },
  [RouteEnum.CRM_CLIENTS_DETAIL as string]: {
    permissions: [Permissions.CanViewCustomers],
    mode: 'any',
  },
  [RouteEnum.CRM_UNIDENTIFIED_PAYER_PAYMENTS as string]: {
    permissions: [Permissions.CanViewCustomers, Permissions.CanViewEvaluations],
    mode: "all",
  },
  ["crm.evaluations.group"]: {
    permissions: [
      Permissions.CanViewEvaluations,
      Permissions.CanViewPepTypes,
      Permissions.CanViewEvaluationReasons,
    ],
    mode: "any",
  },
  [RouteEnum.CRM_EVALUATIONS as string]: {
    permissions: [Permissions.CanViewEvaluations],
    mode: "all",
  },
  [RouteEnum.CRM_EVALUATIONS_DETAIL as string]: {
    permissions: [Permissions.CanViewEvaluations],
    mode: "any",
  },
  [RouteEnum.CRM_EVALUATIONS_CREATE as string]: {
    permissions: [Permissions.CanCreateEvaluations],
    mode: "all",
  },
  [RouteEnum.CRM_PROSPECTS as string]: {
    permissions: [Permissions.CanViewProspects],
    mode: 'all',
  },
  [RouteEnum.CRM_PROSPECTS_DETAIL as string]: {
    permissions: [Permissions.CanViewProspects],
    mode: 'any',
  },
  [RouteEnum.CRM_OPPORTUNITY as string]: {
    permissions: [Permissions.CanViewOpportunities],
    mode: 'all',
  },
  [RouteEnum.CRM_OPPORTUNITY_DETAIL as string]: {
    permissions: [Permissions.CanViewOpportunities],
    mode: 'any',
  },
  [RouteEnum.CRM_PAYMENT_ORDERS as string]: {
    permissions: [Permissions.CanViewPaymentOrders],
    mode: 'all',
  },
  [RouteEnum.CRM_PAYMENT_ORDERS_DETAIL as string]: {
    permissions: [Permissions.CanViewPaymentOrders],
    mode: 'any',
  },
  [RouteEnum.CRM_PENDING_INVOICES as string]: {
    permissions: [Permissions.CanSyncPaymentOrderInvoice],
    mode: 'all',
    featureFlag: FeatureFlagEnum.ERP_INTEGRATION,
  },
  [RouteEnum.CRM_PAYMENTS_WEEK as string]: {
    permissions: [Permissions.CanViewPaymentOrders],
    mode: 'all',
  },
  [RouteEnum.CRM_ACTIVITIES as string]: {
    permissions: [Permissions.CanViewAdvisorActivitiesReport], // TODO: Revisar, no es el permiso corrrecto pero no existe
    mode: 'all',
  },
  [RouteEnum.CRM_COMMISSION_CENTER as string]: {
    permissions: [Permissions.CanViewUserCommissions],
    mode: 'all',
  },
  [RouteEnum.CRM_COMMISSION_CENTER_DETAIL as string]: {
    permissions: [Permissions.CanViewUserCommissions],
    mode: 'any',
  },
  [RouteEnum.CRM_COMMISSION_PAYMENTS as string]: {
    permissions: [Permissions.CanViewPaymentCommissions],
    mode: 'all',
  },
  [RouteEnum.CRM_SALES_ADVISORS as string]: {
    permissions: [Permissions.CanViewUsers], // TODO: Revisar
    mode: 'all',
  },
  [RouteEnum.CRM_PAYMENTS_REQUEST as string]: {
    permissions: [Permissions.CanViewPaymentRequests],
    mode: 'all',
  },
  [RouteEnum.CRM_CESSION as string]: {
    permissions: [Permissions.CanViewCessionOfRights],
    mode: 'all',
  },
  [RouteEnum.CRM_CESSION_DETAIL as string]: {
    permissions: [Permissions.CanViewCessionOfRights],
    mode: 'all',
  },
  [RouteEnum.CRM_PRODUCT_CHANGE as string]: {
    permissions: [Permissions.CanViewChangeOfProducts],
    mode: 'all',
  },
  [RouteEnum.CRM_WITHDRAWALS as string]: {
    permissions: [Permissions.CanReviewPaymentOrderWithdrawals],
    mode: 'all',
  },
  [RouteEnum.CRM_GOAL_COMMISSIONS_MINE as string]: {
    permissions: [Permissions.CanViewOwnGoalCommissions],
    mode: 'all',
  },
  [RouteEnum.CRM_GOAL_COMMISSIONS_MANAGE as string]: {
    permissions: [Permissions.CanViewGoalCommissions],
    mode: 'all',
  },
  [RouteEnum.CRM_GOAL_COMMISSIONS_SETTINGS as string]: {
    permissions: [Permissions.CanManageGoalCommissionSettings],
    mode: 'all',
  },

  // Reportes
  [RouteEnum.CRM_REPORT_OLD_BALANCES as string]: {
    permissions: [Permissions.CanViewOldBalancesReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_CUSTOMER_PAYMENT_STATUS as string]: {
    permissions: [Permissions.CanViewCustomerPaymentStatusReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_CUSTOMER_PAYMENT_GROUP as string]: {
    permissions: [Permissions.CanViewCustomerWalletReport], // TODO: Revisar
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_CLIENTS_BY_QUOTED_PRODUCT as string]: {
    permissions: [Permissions.CanViewClientByProductReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_PENDING_WITHDRAWAL as string]: {
    permissions: [Permissions.CanViewPendingWithdrawalReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_WITHDRAWALS as string]: {
    permissions: [Permissions.CanViewWithdrawalRequestsApprovedReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_PENALTY_WITHDRAWAL as string]: {
    permissions: [Permissions.CanViewWithdrawalRequestsApprovedReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_GENERAL_LEADS as string]: {
    permissions: [Permissions.CanViewGeneralLeadsReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_LOSS_REASONS as string]: {
    permissions: [Permissions.CanViewOpportunitiesKpis, Permissions.CanViewAllKpis],
    mode: 'any',
  },
  [RouteEnum.CRM_REPORT_INTERNAL_EXTERNAL_SALES as string]: {
    permissions: [Permissions.CanViewOpportunitiesKpis, Permissions.CanViewAllKpis],
    mode: 'any',
  },
  [RouteEnum.CRM_REPORT_CUSTOMERS_ADVISOR as string]: {
    permissions: [Permissions.CanViewClientQuoteReport], // TODO: Revisar
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_ADVISOR_PAYMENT_STATUS as string]: {
    permissions: [Permissions.CanViewAdvisorPaymentStatusReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_ADVISOR_ACTIVITIES as string]: {
    permissions: [Permissions.CanViewAdvisorActivitiesReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_TOP_SOLD as string]: {
    permissions: [Permissions.CanViewTopSoldProductReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_TOP_QUOTED as string]: {
    permissions: [Permissions.CanViewTopQuoteProductReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_QUOTED_PRODUCTS_CLIENT as string]: {
    permissions: [Permissions.CanViewClientQuoteReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_OPPORTUNITY_ORIGINS as string]: {
    permissions: [Permissions.CanViewOpportunityOriginsReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_ADVISOR_GOAL as string]: {
    permissions: [Permissions.CanViewAdvisorGoalReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_MASTER as string]: {
    permissions: [Permissions.CanViewMasterOpportunityReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_MASTER_LEADS as string]: {
    permissions: [Permissions.CanViewMasterProspectReport], // TODO: Revisar
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_MASTER_CLIENTS as string]: {
    permissions: [Permissions.CanViewCustomerInfoReport], // TODO: Revisar
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_MASTER_PRODUCTS as string]: {
    permissions: [Permissions.CanViewProductDatasheetReport], // TODO: Revisar
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_AVAILABLE_PRODUCTS as string]: {
    permissions: [Permissions.CanViewAvailableProductsReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_PAYMENTS_HISTORY as string]: {
    permissions: [Permissions.CanViewPaymentHistoryReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_RESERVE_PAYMENTS as string]: {
    permissions: [Permissions.CanViewPaymentReservesHistoryReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_ACTIVE_CUSTOMERS as string]: {
    permissions: [Permissions.CanViewCustomersHistoryReport], // TODO: Revisar
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_DOCUMENTATION as string]: {
    permissions: [Permissions.CanViewDocumentationComplianceReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_PAID_COMMISSIONS as string]: {
    permissions: [Permissions.CanViewPaidCommissionPerMonthReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_PENDING_COMMISSIONS as string]: {
    permissions: [Permissions.CanViewPendingPaymentCommissionReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_COMMISSIONS_PROJECT as string]: {
    permissions: [Permissions.CanViewCommissionsPerProjectReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_COMMISSIONS_AVAILABLE as string]: {
    permissions: [Permissions.CanViewCommissionsAvailableForPaymentReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_ACCOUNTS_RECEIVABLE as string]: {
    permissions: [Permissions.CanViewAccountsReceivableReport],
    mode: "all",
  },
  [RouteEnum.CRM_REPORT_OPPORTUNITY_STEP_TRANSITION_TIME as string]: {
    permissions: [Permissions.CanViewOpportunityStepTransitionTimeReport],
    mode: 'all',
  },
  [RouteEnum.CRM_REPORT_PAYMENT_SAP_RECONCILIATION as string]: {
    featureFlag: FeatureFlagEnum.ERP_INTEGRATION,
    permissions: [Permissions.CanViewOpportunitiesKpis, Permissions.CanViewAllKpis],
    mode: 'any',
  },
  [RouteEnum.CRM_REPORT_RESERVATION_CONTRACT as string]: {
    permissions: [Permissions.CanViewOpportunitiesKpis, Permissions.CanViewAllKpis],
    mode: 'any',
  },
  [RouteEnum.CRM_REPORTS as string]: {
    permissions: [
      Permissions.CanViewOldBalancesReport,
      Permissions.CanViewCustomerPaymentStatusReport,
      Permissions.CanViewCustomerWalletReport,
      Permissions.CanViewPendingWithdrawalReport,
      Permissions.CanViewClientQuoteReport,
      Permissions.CanViewAdvisorPaymentStatusReport,
      Permissions.CanViewTopSoldProductReport,
      Permissions.CanViewOpportunityOriginsReport,
      Permissions.CanViewMasterOpportunityReport,
      Permissions.CanViewMasterProspectReport,
      Permissions.CanViewCustomerInfoReport,
      Permissions.CanViewProductDatasheetReport,
      Permissions.CanViewAvailableProductsReport,
      Permissions.CanViewPaymentHistoryReport,
      Permissions.CanViewPaymentReservesHistoryReport,
      Permissions.CanViewCustomersHistoryReport,
      Permissions.CanViewDocumentationComplianceReport,
      Permissions.CanViewPaidCommissionPerMonthReport,
      Permissions.CanViewPendingPaymentCommissionReport,
      Permissions.CanViewCommissionsPerProjectReport,
      Permissions.CanViewCommissionsAvailableForPaymentReport,
      Permissions.CanViewAccountsReceivableReport,
      Permissions.CanViewOpportunityStepTransitionTimeReport,
    ],
    mode: 'any',
  },

  // Inventario
  [RouteEnum.INVENTORY_PRODUCTS as string]: {
    permissions: [Permissions.CanViewProducts],
    mode: 'all',
  },
  [RouteEnum.INVENTORY_CATEGORIES as string]: {
    permissions: [Permissions.CanViewCategories],
    mode: 'all',
  },
  [RouteEnum.INVENTORY_SUBCATEGORIES as string]: {
    permissions: [Permissions.CanViewSubcategories],
    mode: 'all',
  },
  [RouteEnum.INVENTORY_CHARACTERISTICS as string]: {
    permissions: [Permissions.CanViewDataSheets],
    mode: 'all',
  },

  // Ecommerce
  [RouteEnum.ECOMMERCE_BUSINESS_DATA as string]: {
    permissions: [Permissions.CanViewCompanies],
    mode: 'all',
  },
  [RouteEnum.ECOMMERCE_PROJECTS as string]: {
    permissions: [Permissions.CanViewProjects],
    mode: 'all',
  },
  [RouteEnum.ECOMMERCE_COMMISSIONS as string]: {
    permissions: [Permissions.CanViewProjectCommissions],
    mode: 'all',
  },

  // Global Config
  [RouteEnum.GLOBAL_CONFIG_AD_CAMPAIGN]: {
    permissions: [Permissions.CanSendAdCampaigns],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_BANKS]: {
    permissions: [Permissions.CanViewBanks],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_PAYMENT_ACCOUNTS]: {
    permissions: [Permissions.CanViewPaymentAccounts],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_DOCUMENT]: {
    permissions: [
      Permissions.CanViewDocumentTypes,
      Permissions.CanViewTypeDocumentModule,
    ],
    mode: 'any',
  },
  [RouteEnum.GLOBAL_CONFIG_DOCUMENT_LIST]: {
    permissions: [
      Permissions.CanViewDocumentTypes,
      Permissions.CanViewTypeDocumentModule,
    ],
    mode: "all",
  },
  [RouteEnum.GLOBAL_CONFIG_DOCUMENT_TYPE]: {
    permissions: [Permissions.CanViewTypeDocumentModule],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_ORIGIN_TYPE]: {
    permissions: [Permissions.CanViewTypeOrigins],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_PEP_TYPES]: {
    permissions: [Permissions.CanViewPepTypes],
    mode: "all",
  },
  [RouteEnum.GLOBAL_CONFIG_EVALUATION_REASONS]: {
    permissions: [Permissions.CanViewEvaluationReasons],
    mode: "all",
  },
  [RouteEnum.GLOBAL_CONFIG_ACTIVITY_LIST]: {
    permissions: [Permissions.CanViewTypeActivities],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_ACTIVITY_TYPE]: {
    permissions: [Permissions.CanViewTypeActivityModule],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_TYPE_COMMISSIONS]: {
    permissions: [Permissions.CanViewCommissionTypes],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_MEASURE_UNIT]: {
    permissions: [Permissions.CanViewUnitOfMeasurements],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_GOALS]: {
    permissions: [Permissions.CanViewGoal, Permissions.CanViewGoalMetric],
    mode: 'any',
  },
  [RouteEnum.GLOBAL_CONFIG_GOAL_NEW]: {
    permissions: [Permissions.CanCreateGoal],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_GOAL_EDIT]: {
    permissions: [Permissions.CanEditGoal],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_GOAL_METRICS]: {
    permissions: [Permissions.CanViewGoalMetric, Permissions.CanViewGoal],
    mode: 'any',
  },
  [RouteEnum.GLOBAL_CONFIG_GOAL_PARAMETERS]: {
    permissions: [
      Permissions.CanViewGoal,
      Permissions.CanViewGoalMetric,
    ],
    mode: 'any',
  },
  [RouteEnum.GLOBAL_CONFIG_STATUS_LIST]: {
    permissions: [Permissions.CanViewStatuses],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_STATUS_TYPES]: {
    permissions: [Permissions.CanViewTypeStatuses],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_STATUS]: {
    permissions: [Permissions.CanViewStatuses, Permissions.CanViewTypeStatuses],
    mode: 'any',
  },
  [RouteEnum.GLOBAL_CONFIG_LOCATIONS_DEPARTMENTS]: {
    permissions: [Permissions.CanViewDepartments],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_LOCATIONS_CITIES]: {
    permissions: [Permissions.CanViewCities],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_LOCATIONS]: {
    permissions: [Permissions.CanViewDepartments, Permissions.CanViewCities],
    mode: 'any',
  },
  [RouteEnum.GLOBAL_CONFIG_WIN_REASONS]: {
    permissions: [Permissions.CanViewWinReasons],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_LOSS_REASONS]: {
    permissions: [Permissions.CanViewLossReasons],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_LOSS_REASON_CATEGORIES]: {
    permissions: [Permissions.CanViewLossReasons],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_PAYMENT_REASONS]: {
    permissions: [Permissions.CanViewReasonsForRequest],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_ROLES]: {
    permissions: [Permissions.CanViewRoles],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_USERS]: {
    permissions: [Permissions.CanViewUsers],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_NOTIFICATIONS]: {
    permissions: [Permissions.CanViewNotifications],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_DISCARD_REASONS]: {
    permissions: [Permissions.CanViewDiscardReasons],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_PROSPECT_STEP_STATUS]: {
    permissions: [Permissions.CanViewProspectStepStatus],
    mode: 'all',
  },
  [RouteEnum.GLOBAL_CONFIG_DISCOUNT_TYPES]: {
    permissions: [Permissions.CanViewDiscountTypes],
    mode: "all",
  },
  [RouteEnum.GLOBAL_CONFIG_EXCHANGE_RATES]: {
    permissions: [Permissions.CanViewExchangeRates],
    mode: 'all',
    hideWhenFeatureEnabled: FeatureFlagEnum.ERP_INTEGRATION,
  },
}
